// Sprint 8 — Perfil público
import { Fragment, type ReactNode } from "react";

function splitBoldSegments(line: string): (string | { bold: string })[] {
  const out: (string | { bold: string })[] = [];
  let i = 0;
  while (i < line.length) {
    const start = line.indexOf("**", i);
    if (start === -1) {
      out.push(line.slice(i));
      break;
    }
    if (start > i) out.push(line.slice(i, start));
    const end = line.indexOf("**", start + 2);
    if (end === -1) {
      out.push(line.slice(start));
      break;
    }
    out.push({ bold: line.slice(start + 2, end) });
    i = end + 2;
  }
  return out;
}

function parseItalicInPlainSegment(segment: string, keyPrefix: string): ReactNode[] {
  const nodes: ReactNode[] = [];
  let last = 0;
  const re = /\*([^*]+)\*/g;
  let m: RegExpExecArray | null;
  let k = 0;
  while ((m = re.exec(segment)) !== null) {
    if (m.index > last) {
      nodes.push(segment.slice(last, m.index));
    }
    nodes.push(<em key={`${keyPrefix}-em-${k++}`}>{m[1]}</em>);
    last = m.index + m[0].length;
  }
  if (last < segment.length) nodes.push(segment.slice(last));
  return nodes;
}

function parseLineToNodes(line: string, lineKey: string): ReactNode[] {
  const parts = splitBoldSegments(line);
  const out: ReactNode[] = [];
  let i = 0;
  for (const p of parts) {
    if (typeof p === "string") {
      out.push(...parseItalicInPlainSegment(p, `${lineKey}-${i}`));
    } else {
      const inner = parseItalicInPlainSegment(p.bold, `${lineKey}-b-${i}`);
      out.push(
        <strong key={`${lineKey}-strong-${i}`}>
          {inner.length ? inner : p.bold}
        </strong>,
      );
    }
    i += 1;
  }
  return out;
}

/** Markdown mínimo: **negrita**, *cursiva*, saltos de línea (sin dependencias). */
export function renderPublicBioMarkdown(text: string | null | undefined): ReactNode {
  if (!text?.trim()) return null;
  const blocks = text.split(/\n\n+/);
  return blocks.map((block, bi) => {
    const lines = block.split("\n");
    return (
      <p
        key={`p-${bi}`}
        style={{ margin: bi === 0 ? 0 : "0.75rem 0 0", lineHeight: 1.55 }}
      >
        {lines.map((line, li) => (
          <Fragment key={`ln-${bi}-${li}`}>
            {li > 0 ? <br /> : null}
            {parseLineToNodes(line, `${bi}-${li}`)}
          </Fragment>
        ))}
      </p>
    );
  });
}
